export type i18nLanguage = {
  name: string;
  /** BCP 47 locale code — used both as directory name and runtime code. */
  languageCode: string;
  /** @deprecated Use languageCode. Retained for backward compatibility during migration. */
  localePath: string;
  isDefault?: boolean;
};

const defaultLanguage: i18nLanguage = {
  name: 'English',
  localePath: 'en-US',
  languageCode: 'en-US',
  isDefault: true,
};

export const languages: i18nLanguage[] = [
  defaultLanguage,
  {
    name: 'English (UK)',
    localePath: 'en-GB',
    languageCode: 'en-GB',
  },
  {
    name: 'English (AU)',
    localePath: 'en-AU',
    languageCode: 'en-AU',
  },
  {
    name: 'Deutsch',
    localePath: 'de-DE',
    languageCode: 'de-DE',
  },
  {
    name: 'Español',
    localePath: 'es-ES',
    languageCode: 'es-ES',
  },
  {
    name: 'Français',
    localePath: 'fr-FR',
    languageCode: 'fr-FR',
  },
  {
    name: 'Italiano',
    localePath: 'it-IT',
    languageCode: 'it-IT',
  },
  {
    name: '日本語',
    localePath: 'ja-JP',
    languageCode: 'ja-JP',
  },
];

const languagesByLocale = new Map(languages.map((lang) => [lang.languageCode, lang]));

export const BUILD_LANGUAGE = typeof __BUILD_LOCALE__ !== 'undefined' ? languagesByLocale.get(__BUILD_LOCALE__)?.languageCode : undefined;

export const DEFAULT_LANGUAGE = defaultLanguage.languageCode;
export const FALLBACK_LANGUAGE = BUILD_LANGUAGE ?? DEFAULT_LANGUAGE;

export const resolveLanguage = (extendedLanguageCode?: string): i18nLanguage => {
  if (!extendedLanguageCode) {
    return defaultLanguage;
  }
  const normalizedLanguageCode = extendedLanguageCode.toLowerCase();
  const [languageCode] = normalizedLanguageCode.split('-');

  let baseMatch: i18nLanguage | undefined;

  for (const language of languages) {
    const code = language.languageCode.toLowerCase();

    if (code === normalizedLanguageCode) {
      return language;
    }

    if (!baseMatch && code.startsWith(languageCode)) {
      baseMatch = language;
    }
  }

  return baseMatch ?? defaultLanguage;
};
